import { useQuery } from "react-query";
import { zodParseWithLog } from "src/api/apiErrorLogs";
import { loggedInApiCall } from "src/api/axiosClient/userApi";
import { z } from "zod";
import { CompanySchema, Company } from "./organizationSchema";

// Simple hierarchy schema - API Platform will return standard Company entities
const CompanyHierarchyResponseSchema = z.object({
    "@context": z.string(),
    "@type": z.string(),
    "hydra:member": z.array(CompanySchema),
    "hydra:totalItems": z.number(),
});

export type CompanyHierarchyNode = Company;

// Type for companies with hierarchy relations
export type CompanyHierarchy = Company & {
    parents?: CompanyHierarchy[];
    children?: CompanyHierarchy[];
};

export const useOrganizationHierarchy = () => {
    const query = useQuery({
        queryKey: ["company-hierarchy"],
        queryFn: async () => {
            const response = await loggedInApiCall.get("/api/organizations/hierarchy");
            return response;
        },
        select: (request) => {
            const data = zodParseWithLog(request.data, CompanyHierarchyResponseSchema, "companyHierarchy");

            return {
                rootCompanies: data["hydra:member"],
                totalItems: data["hydra:totalItems"],
            };
        },
    });

    return {
        rootCompanies: query.data?.rootCompanies,
        totalItems: query.data?.totalItems,
        isLoading: query.isLoading,
        error: query.error,
    };
};
